module.exports = __webpack_public_path__ + "static/media/person-2-full.27905c9a.png";